import { z } from 'zod/v4'

export const userPointValidation = () => {
  return z.object({
    date: z.date({ message: 'Date is required' }).min(1, { message: 'Date is required' }),
    value: z.coerce.number({ message: 'Point is required' }).min(1, { message: 'Point must higher than 0' }),
    method: z.string().min(1, { message: 'Form is required' }),
    type: z.string({ message: 'Please select a type' }).min(1, { message: 'Form is required' }),
  })
}